import classnames from 'classnames';
import { cloneElement, isValidElement, useState } from 'react';

import styles from 'molecules/MobilePopup/mobile-pop-up-menu.module.scss';

import useBodyClass from 'utils/hooks/useBodyClass';

import type { FC, ReactNode } from 'react';

interface MobilePopUpMenuProps {
  children: ReactNode;
  openImage?: ReactNode;
  closeImage?: ReactNode;
  openText: string | ReactNode;
  closeText: string | ReactNode;
  panelHeading?: string;
}

interface ChildWithOnLinkClickProps {
  onLinkClick?: () => void;
}

const MobilePopUpMenu: FC<MobilePopUpMenuProps> = ({
  children,
  openImage,
  closeImage,
  openText,
  closeText,
  panelHeading,
}) => {
  const [hidden, setHidden] = useState(true);
  const toggle = () => setHidden(prev => !prev);

  useBodyClass(hidden ? '' : 'fixedBody');

  return (
    <>
      <button
        onClick={toggle}
        className={classnames(styles.popUpButton, {
          [styles.popUpButtonClose]: !hidden,
        })}
        aria-expanded={!hidden}
      >
        {hidden ? openImage : closeImage}
        {hidden ? openText : closeText}
      </button>
      <div
        className={classnames(styles.popUpPanel, {
          [styles.popUpPanelOpen]: !hidden,
        })}
      >
        <div className={styles.inner}>
          <h2>{panelHeading}</h2>
          {isValidElement<ChildWithOnLinkClickProps>(children)
            ? cloneElement(children, {
                onLinkClick: () => setHidden(true),
              })
            : children}
        </div>
      </div>
    </>
  );
};

export default MobilePopUpMenu;
